import React,{useState, useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import styles1 from "./Zoning.module.css";
import styles2 from "./ZoningArb.module.css"
import Button from '@material-ui/core/Button';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import CustomizedAlert from '../../../../ReusableComponents/Alert/CustomizedAlert';
import { GetStateFromData } from '../../../CustomHooks/CustomHooks';

const useStyles = makeStyles({
    btn: {
        height:"2.335rem !important",
        width: "43px !important",  
        // height: "22px",
        background: "#0072C6 0% 0% no-repeat padding-box",
        borderRadius: "2px",
        opacity: 1,
        marginTop: '-2% !important',
        marginRight: "0px !important",
        padding: "5px 8px 6px 8px",
        '&:hover': {
            background: "#0072C6",
        }
    },
    btnlabel: {
        textTransform: "none",
        font: "normal normal 600 8px/11px Open Sans",
        color: "#ffffff",
    },
    icon: {
        height: "10px",
        width: "10px",
        color: "grey"
    },
    icon2: {
        height: "15px",
        width: "15px",
        color: "grey"
    },
    config: {
        borderRadius: "unset !important",
        caretColor: "transparent",
        margin: 0,
        height: "20px !important",
    },
    configHeader: {
        height: "26px",
        textAlign: "left",
        padding: "6px 0px 5px 8px !important",
        fontFamily: "Open Sans",
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "14px",
        letterSpacing: "0px",
        color: "#000000",
        margin: 0,
        cursor: "pointer",
        backgroundColor: "#FFFFFF",
        borderBottom: "0.5px solid #C4C4C4",
        opacity: 1,
    },
    configHeaderDiv: {
        minWidth: "243px",
        paddingRight: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#202020",
    },
    headSpan1: {
        textAlign: "center",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color:  "#C4C4C4",
        opacity: 1,
        marginRight: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "0px":"12px",
        marginLeft: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "12px": "0px",
    },
    headSpan2: {
        maxWidth: "90%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    headSpan3: {
        textAlign: "center",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color:" #C4C4C4",
        opacity: 1,
        margin: "5px 7px 0px 0px",
    },
    downArrow: {
        float: "right",
        marginRight: "8px",
    },
    arrowsAdjustment: {
        marginRight: "6px",
    },
    cardBodyProp: {
        padding: "11px 13px 12px 8px",
        borderBottom: "0.5px solid #C4C4C4",
        width: "100%",
    },
    cardBodyHead: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
    },
    cardBody: {
        color: "#000000",
    },
    label: {
        height: "24px",
        width: "167px",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
        padding: "5px 0px 4px 7px",
        marginBottom: "6px",
        textAlign: "left",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
    right: {
        height: 24,
        marginBottom: "6px",
        flex: 1,
        display: "flex",
        justifyContent: "flex-end",
    },
    left: {
        height: "24px",
        width: "21.5%",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
        marginTop: "6px",
        marginBottom: "5px",
        marginRight: "14.7%",
        textAlign: "left",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
    width: {
        height: "24px",
        width: "21.5%",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
        marginTop: "6px",
        marginBottom: "5px",
        marginRight: "14.7%",
        textAlign: "left",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
    top: {
        height: "24px",
        width: "21.5%",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
        marginTop: "6px",
        marginBottom: "5px",        
        textAlign: "left",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
    height: {
        height: "24px",
        width: "21.5%",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
        marginTop: "6px",
        marginBottom: "5px",        
        textAlign: "left",
        font: "normal normal 600 11px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
    text: {
        height: "24px",
        width: "17.5%",
        marginLeft: "7px",
        paddingTop: "10px",
        letterSpacing: "0px",
        color: "#000000",
        opacity: 1,
    },
});

function ZoneCard({containerId,heading, state, zone, index, pageNo, multi, zoneList, setZoneList, bodyStyle, handleState, handleChange2, controlled,Name, inlineStyle,headerStyling,divStyling}){
  const contexts = GetStateFromData(containerId);
   const classes = useStyles();
   const [left, setLeft] = useState(zone.Left);
   const [top, setTop] = useState(zone.Top);
   const [width, setWidth] = useState(zone.Width);
   const [height, setHeight] = useState(zone.Height);
   const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
});
   const [deleteCondition, setDeleteCondition] = useState(false);
   const arr = zone.name.split("_");
   const [name, setName] = useState(arr[1]);
   const [page, setPage] = useState(arr[0]);
   const zoning = document.getElementById('zoning');

   const styles = window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? styles2 : styles1;
   const { t } = useTranslation();
   useEffect(() => {
    setName(arr[1]);
    setPage(arr[0]);
   }, [zone.name, zone])

   useEffect(() => {
    if (deleteCondition) {
        var array = [...zoneList];
        array.splice(index, 1)
        setZoneList(array);
        if(zoning){
            zoning.textContent="";
        }
        setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "ZONE_REMOVED",
            autoHideDuration: 4000
          });
        setDeleteCondition(false);
    }
   },[deleteCondition]);

   if(zoning){
        if(index === state){
            zoning.textContent="";
            let element = document.createElement('div');
            element.className = 'rectangle';
            element.style.position = "absolute";
            element.style.border = "2px solid #FF0000";
            element.style.left = zoneList[index].Left + 'px';
            element.style.top = zoneList[index].Top + 'px';
            element.style.height = zoneList[index].Height + 'px';
            element.style.width = zoneList[index].Width + 'px';
            zoning.appendChild(element)
        } else if(state === -1){
            zoning.textContent="";    
        }
    }
   

  
    function handleClick(x){
        if(handleState){
            handleState(x);
        }
        if(multi){
            if (page !== pageNo){
                handleChange2(page);
            }    
        } else {
            if(page != 1){
                if(zoning){
                    zoning.textContent=""; 
                }
            }
        }

    }

    function handleEditClick(e,ind) {
        e.stopPropagation();
        const lastValue=zoneList[ind]["name"];

        if(zoneList.some((doc) => (doc.name).trim() === (page + "_" + name).trim()) && (lastValue.trim() !== (page + "_" + name).trim())){
              setAlertData({
                'open':true,
                "alertContentMsg": `${t("A zone with this name already exists. Please choose a different name.")}`,
                'showConfirm':'showNotification',
                'alertType':'error',
                "autoHideDuration": 4000,
            })
        }
        else{
            let temp = {};
            temp["name"] = page + "_" + name;
            temp["Left"] = left;
            temp["Top"] = top;
            temp["Width"] = width;
            temp["Height"] = height;
            if(zoneList[index].name !== temp["name"] || zoneList[index].Left !== temp["Left"] || zoneList[index].Top !== temp["Top"] || zoneList[index].Width !== temp["Width"] || zoneList[index].Height !== temp["Height"]) {
                var array = [...zoneList];
                array.splice(index, 1, temp);
                setZoneList(array);
                setAlertData({
                    'open':true,
                    "alertContentMsg": `${t("ZONE_MODIFIED")}`,
                    'showConfirm':'showNotification',
                    'alertType':'success',
                    "autoHideDuration": 4000,
                })

                // setTimeout(() => {
                //     setAlertData({
                //         'open':false,
                //         "alertContentMsg": `${t("ZONE_MODIFIED")}`,
                //         'showConfirm':'showNotification',
                //         'alertType':'success',
                //     })
                // }, 2000)
            }
        handleState(index);
        }
    }

    function handleDelete(index){        
        setAlertData({
            'open':true,
            'showConfirm':'showconformationDialogBox',
            'alertContentKey':'DeleteConfirmationContent',
            'alertTitleKey':`${t("translation:DeleteConfirmationTitleDynamic")} ${zoneList[index].name} ?`, 
            "Button1Key" : `${t('Cancel')}`,
            "Button2Key" : `${t('Confirm')}`,
            "deleteZone" : true,
            "dynamicTitle":true
        })
    }

    return (
        <>
        <div className={styles.config} key={index} >
            {index !==  state? 
            <div className={styles.configHeader} key={index} onClick={() => handleClick(index)}>
                <div className={styles.configHeaderDiv} >
                    
                        {window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?
                        <div className={styles.headSpan2}>
                            <span>{name}</span>
                            <span className={styles.headSpan11}>{page}</span>
                        </div>
                        :
                        <div className={styles.headSpan2}>
                            <span className={styles.headSpan1}>{page}</span>
                            <span>{name}</span>
                        </div>
                        }
                    
                    <div className={styles.arrowsAdjustment} style={{display:'flex',alignItems:'center'}}>
                        <span onClick={()=>handleClick(index)} > <img src={require("../../../../Icons/Zoning/Edit.svg").default} className={classes.icon} alt="Edit Icon"/> </span> &nbsp; &nbsp;
                        <span onClick={()=>handleDelete(index)}>  <DeleteOutlineOutlinedIcon className={classes.icon2}/></span>
                    </div>
                </div>
            </div>
                        
            :
                   
            <div style={{...bodyStyle,caretColor:"black"}} className={styles.cardBodyProp} key={index} onClick={()=>handleClick(-1)}>
                <>
                <div className={`${styles.cardBodyHead} ${styles.cardbody__header}`}>
                    <div className={styles.headSpan3}> {page} </div>
                    <input aria-label={"Page Name"}  type="text" value={name} maxLength={window?.psh_configs?.label_max_length} onChange={(e) => setName(e.target.value)} className={styles.label} onClick={e =>  e.stopPropagation()} />
                    <div style={{marginRight: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "3px": null}} className={classes.right}> 
                        <Button disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`} onClick={e => handleEditClick(e,index)} classes={{root:classes.btn,label:classes.btnlabel}}> 
                            {t("Modify")} 
                        </Button> 
                    </div>
                </div>
                <div className={styles.cardBodyHead}>
                    <div className={styles.text}> {t("Left")} </div>
                    <input aria-label={"Page Left"} type="text" defaultValue={zone.Left}  onChange={(e) => setLeft(e.target.value)} className={styles.left} onClick={e =>  e.stopPropagation()} />
                    <div className={styles.text}> {t("Top")} </div>
                    <input aria-label={"Page Top"} type="text" defaultValue={zone.Top} onChange={(e) => setTop(e.target.value)} className={styles.top}  onClick={e =>  e.stopPropagation()} />  
                </div>
                <div className={styles.cardBodyHead} >
                    <div className={styles.text}> {t("Width")} </div>
                    <input aria-label={"Page Width"} type="text" defaultValue={zone.Width} onChange={(e) => setWidth(e.target.value)} className={styles.width}  onClick={e =>  e.stopPropagation()} />
                    <div className={styles.text}> {t("Height")} </div>
                    <input aria-label={"Page Height"} type="text" defaultValue={zone.Height} onChange={(e) => setHeight(e.target.value)} className={styles.height}  onClick={e =>  e.stopPropagation()} />  
                </div>
                </>

                
            </div>
            }
        </div>
        {
        alertData.open === true &&
            <CustomizedAlert alertData={alertData} setDeleteCondition={setDeleteCondition}/>
        }
        </>
         )
}

export default ZoneCard